module.exports = __webpack_public_path__ + "images/bv-logo-old.svg";